// 如果您已集成 v2.x 的 SDK，想升级到 V3 并且想尽可能地少改动项目代码，可以继续沿用 TIM
// import TIM from '@tencentcloud/chat';
import TencentCloudChat from '@tencentcloud/chat';
import TIMUploadPlugin from 'tim-upload-plugin';
// 存储 TIM 实例
let tim = null;

// 存储当前用户信息
const currentUser = {
    userID: '',
    userSig: '',
};

const eventBus = {
    listeners: {},

    on(event, callback) {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push(callback);
    },

    off(event, callback) {
        if (this.listeners[event]) {
            this.listeners[event] = this.listeners[event].filter((cb) => cb !== callback);
        }
    },

    emit(event, data) {
        if (this.listeners[event]) {
            this.listeners[event].forEach((cb) => {
                try {
                    cb(data);
                } catch (err) {
                    console.error('Event listener error:', err);
                }
            });
        }
    },
};
// ✅ 修复 this 指向
eventBus.on = eventBus.on.bind(eventBus);
eventBus.off = eventBus.off.bind(eventBus);
eventBus.emit = eventBus.emit.bind(eventBus);

// 初始化 TIM 实例
function initTIM() {
    if (tim) return tim;

    tim = TencentCloudChat.create({
        SDKAppID: 1600099650,
    }); // 替换为你的 SDKAppID

    // 设置日志等级
    tim.setLogLevel(1); // 建议开发时设置为 0，生产环境设置为 1

    // 注册腾讯云即时通信 IM 上传插件
    tim.registerPlugin({
        'tim-upload-plugin': TIMUploadPlugin,
    });

    // 监听事件
    tim.on(TencentCloudChat.EVENT.SDK_READY, onReadyStateUpdate);
    tim.on(TencentCloudChat.EVENT.SDK_NOT_READY, onNotReadyStateUpdate);
    tim.on(TencentCloudChat.EVENT.KICKED_OUT, onKickedOut);
    tim.on(TencentCloudChat.EVENT.ERROR, onError);
    tim.on(TencentCloudChat.EVENT.MESSAGE_RECEIVED, onMessageReceived);
    tim.on(TencentCloudChat.EVENT.CONVERSATION_LIST_UPDATED, onConversationListUpdated);

    return tim;
}

// 登录
async function login(userID, userSig) {
    if (!tim) {
        initTIM();
    }
    currentUser.userID = userID;
    currentUser.userSig = userSig;

    try {
        await tim.login({
            userID,
            userSig,
        });
        console.log('IM 登录成功');
        return {
            success: true,
        };
    } catch (error) {
        console.error('IM 登录失败:', error);
        return {
            success: false,
            error,
        };
    }
}

// 登出
async function logout() {
    try {
        await tim.logout();
        console.log('IM 登出成功');
        // 清理状态
        currentUser.userID = '';
        currentUser.userSig = '';
        eventBus.emit('logout');
    } catch (error) {
        console.error('IM 登出失败:', error);
    }
}

// 发送消息
async function sendMessage(to, text, id) {
    console.log(to);
    console.log(text);
    console.log(id);

    if (!tim || !tim.getConversationProfile) {
        return {
            success: false,
            error: 'IM 未就绪',
        };
    }

    const message = tim.createTextMessage({
        to: to,
        conversationType: TencentCloudChat.TYPES.CONV_C2C,
        payload: {
            text: text,
            id: id,
        },
    });

    try {
        const res = await tim.sendMessage(message);
        console.log('消息发送成功:', res);
        return {
            success: true,
            message: res,
        };
    } catch (error) {
        console.error('消息发送失败:', error);
        return {
            success: false,
            error,
        };
    }
}

// 发送消息
async function sendImage(to, file) {
    // 返回一个 Promise
    if (!tim || !tim.getConversationProfile) {
        return {
            success: false,
            error: 'IM 未就绪',
        };
    }
    let message = tim.createImageMessage({
        to: to,
        conversationType: TencentCloudChat.TYPES.CONV_C2C,
        payload: {
            file: file,
        },
        onProgress: function (event) {
            console.log('file uploading:', event);
        },
    });
    // 2. 发送消息
    const res = await tim.sendMessage(message);
    console.log('消息发送成功:', res);
    return {
        success: true,
        message: res,
    };
}
async function sendVideo(to, file) {
    // 返回一个 Promise
    if (!tim || !tim.getConversationProfile) {
        return {
            success: false,
            error: 'IM 未就绪',
        };
    }
    let message = tim.createVideoMessage({
        to: to,
        conversationType: TencentCloudChat.TYPES.CONV_C2C,
        payload: {
            file: file,
        },
        onProgress: function (event) {
            console.log('file uploading:', event);
        },
    });
    // 2. 发送消息
    const res = await tim.sendMessage(message);
    console.log('消息发送成功:', res);
    return {
        success: true,
        message: res,
    };
}

// 获取会话列表
async function getConversationList() {
    try {
        const res = await tim.getConversationList();
        console.log(res, 'sdk获取的会话列表');
        return res.data.conversationList || []; // 安全返回
    } catch (error) {
        console.error('获取会话列表失败:', error);
        return [];
    }
}

// 获取历史消息
async function getMessageList(conversationID, nextReqMessageID = '', count = 15) {
    try {
        const options = {
            conversationID: conversationID,
            count: count,
        };
        if (nextReqMessageID) {
            options.nextReqMessageID = nextReqMessageID;
        }
        const res = await tim.getMessageList(options);
        console.log(res, '获取消息列表成功');
        return res;
    } catch (error) {
        console.error('获取消息列表失败:', error);
        return {
            messageList: [],
            isCompleted: true,
        };
    }
}

// 事件处理函数
function onReadyStateUpdate(event) {
    console.log('IM SDK Ready');
    eventBus.emit('sdkReady', event);
}

function onNotReadyStateUpdate(event) {
    console.log('IM SDK Not Ready');
    eventBus.emit('sdkNotReady', event);
}

function onKickedOut(event) {
    console.warn('被踢下线:', event);
    eventBus.emit('kickedOut', event);
    // 通常需要重新登录
}

function onError(error) {
    console.error('IM 错误:', error);
    eventBus.emit('error', error);
}

function onMessageReceived(event) {
    const messageList = event.data; // 一条或多条消息
    console.log('收到新消息:', messageList);
    eventBus.emit('messageReceived', messageList);
}

function onConversationListUpdated(event) {
    const conversationList = event.data;
    console.log('会话列表更新:', conversationList);
    eventBus.emit('conversationListUpdated', conversationList);
}

// 删除会话
async function deleteConversation(conversationID) {
    // 参数校验
    if (!conversationID) {
        console.warn('deleteConversation: conversationID 不能为空');
        return {
            success: false,
            error: 'conversationID 为空',
        };
    }

    try {
        const options = {
            conversationIDList: [conversationID], // 将单个 ID 转换为数组
        };
        const res = await tim.deleteConversation(options);

        console.log('删除会话成功', res.data.conversation);
        return {
            success: true,
            data: res.data.conversation, // 返回被删除的会话信息（可选）
        };
    } catch (error) {
        console.error('删除会话失败:', error);
        return {
            success: false,
            error: error,
        };
    }
}

// 将某会话下所有未读消息已读上报
async function setMessageRead(conversationID) {
    // 参数校验
    if (!conversationID) {
        console.warn('setMessageRead: conversationID 不能为空');
        return {
            success: false,
            error: 'conversationID 为空',
        };
    }

    try {
        const options = {
            conversationID: conversationID, // 将单个 ID 转换为数组
        };
        const res = await tim.setMessageRead(options);
        return {
            success: true,
            data: res.data.conversation, // 返回被删除的会话信息（可选）
        };
    } catch (error) {
        console.error('失败:', error);
        return {
            success: false,
            error: error,
        };
    }
}

function generateAbstractList(messageList) {
    return messageList.map((msg) => {
        const sender = msg.nick || '未知用户';
        let text = '';

        switch (msg.type) {
            case 'TIMTextElem':
                text = msg.payload?.text?.trim() || '';
                break;
            case 'TIMImageElem':
                text = '[图片]';
                break;
            case 'TIMVideoFileElem':
                text = '[视频]';
                break;
            default:
                text = '[未知消息]';
        }

        // 拼接发送者和内容，限制长度
        const abstract = `${sender}: ${text}`;
        return abstract.length > 50 ? abstract.slice(0, 47) + '...' : abstract;
    });
}
// utils/generateMergerTitle.js

/**
 * 自动生成合并消息的标题：如 "你 与 张医生 的聊天记录"
 * @param {string} friendUserID - 对方用户ID
 * @param {string} myName - 当前用户的昵称（可选）
 * @returns {Promise<string>}
 */
async function generateMergerTitle(friendUserID, myName = '你') {
    console.log(friendUserID, 'friendUserID');

    try {
        // 查询对方用户资料
        const res = await tim.getUserProfile({
            userIDList: [friendUserID],
        });
        console.log(res, '用户信息');
        const userProfile = res.data[0];
        const friendName = userProfile?.nick || userProfile?.userID || friendUserID;

        // 生成标题
        return `${myName} 与 用户 ${friendName} 的聊天记录`;
    } catch (error) {
        console.warn('获取用户资料失败，使用默认标题', error);
        return `与 ${friendUserID} 的聊天记录`;
    }
}

// 合并转发
async function createMergerMessage(userID, messageList, flowUserId) {
    try {
        const abstractList = generateAbstractList(messageList);
        // ✅ 自动生成标题（假设你知道当前用户的名称）
        const myName = localStorage.getItem('userName') || '你'; // 可从 Vuex、Pinia 或本地存储获取
        const title = await generateMergerTitle(flowUserId, myName);
        let mergerMessage = tim.createMergerMessage({
            to: userID,
            conversationType: TencentCloudChat.TYPES.CONV_C2C,
            payload: {
                messageList: [...messageList],
                title: title,
                abstractList: abstractList,
                compatibleText: '请升级IMSDK到v2.10.1或更高版本查看此消息',
            },
        });
        const res = await tim.sendMessage(mergerMessage);
        return {
            success: true,
            data: res.data.conversation, // 返回被删除的会话信息（可选）
        };
    } catch (error) {
        console.error('失败:', error);
        return {
            success: false,
            error: error,
        };
    }
}

// 导出方法
export default {
    login,
    logout,
    sendMessage,
    sendImage,
    sendVideo,
    getConversationList,
    getMessageList,
    deleteConversation,
    setMessageRead,
    createMergerMessage,
    // 获取当前用户
    getCurrentUser() {
        return {
            ...currentUser,
        };
    },
    // 事件监听
    on: eventBus.on,
    off: eventBus.off,
    // 检查是否已登录
    isLogin() {
        return tim && tim.getMyProfile;
    },
    // 获取 TIM 实例（谨慎使用）
    getTIM() {
        return tim;
    },
};
